// 日本語
import type { Messages } from "./pt-BR";

const ja: Messages = {
  "common.loading": "読み込み中…",
  "common.close": "閉じる",
  "common.back": "戻る",
  "common.theme": "テーマ切り替え",
  "common.language": "言語",
  "common.error": "エラーが発生しました。もう一度お試しください。",

  "auth.login": "ログイン",
  "auth.loginField": "ユーザー名またはメール",
  "auth.password": "パスワード",
  "auth.forgotLink": "パスワードを忘れた",
  "auth.newHere": "はじめての方は",
  "auth.createAccount": "アカウント作成",
  "auth.haveAccount": "アカウントをお持ちの方は",
  "auth.username": "ユーザー名",
  "auth.usernameHint": "3〜20文字: 英小文字・数字・_ 。ログインに使います。",
  "auth.email": "メールアドレス",
  "auth.emailHint": "確認リンクを送ります。パスワードの再設定に使います。",
  "auth.nickname": "ニックネーム",
  "auth.nicknameHint": "試合で表示される名前（3〜16文字）。",
  "auth.passwordHint": "8文字以上。",
  "auth.confirm": "パスワード（確認）",
  "auth.err.login": "ユーザー名またはメールを入力してください。",
  "auth.err.password": "パスワードを入力してください。",
  "auth.err.username": "3〜20文字: 英小文字・数字・_ 。",
  "auth.err.email": "メールアドレスが正しくありません。",
  "auth.err.nickname": "ニックネームは3〜16文字にしてください。",
  "auth.err.passwordShort": "8文字以上にしてください。",
  "auth.err.confirm": "パスワードが一致しません。",
  "auth.forgot": "パスワード再設定",
  "auth.forgotText": "メールアドレスを入力してください。アカウントがあれば、30分有効のリンクを送ります。",
  "auth.sendLink": "リンクを送る",
  "auth.backToLogin": "ログインに戻る",
  "auth.forgotSent": "登録済みのメールなら、まもなくリンクが届きます。迷惑メールフォルダも確認してください。",
  "auth.newPassword": "新しいパスワード",
  "auth.newPasswordTitle": "新しいパスワードを作成",
  "auth.savePassword": "パスワードを保存",
  "auth.passwordChanged": "パスワードを変更しました！新しいパスワードでログインしてください。",
  "auth.linkIncomplete": "リンクが不完全です。パスワード再設定から新しいリンクを請求してください。",
  "auth.verifyTitle": "メール確認",
  "auth.verifying": "確認中…",
  "auth.goMenu": "メニューへ",
  "auth.verified": "メールを確認しました！",
  "auth.verifyFailed": "リンクが無効か期限切れです。メニューから確認リンクを再送してください。",

  "err.offline": "サーバーに接続できません。インターネット接続を確認してください。",
  "err.invalidCredentials": "ユーザー名、メール、またはパスワードが違います。",
  "err.tooManyAttempts": "試行回数が多すぎます。数分待ってからもう一度お試しください。",
  "err.rateLimited": "リクエストが多すぎます。少し待ってください。",
  "err.usernameTaken": "このユーザー名はすでに使われています。",
  "err.emailTaken": "このメールアドレスのアカウントはすでにあります。",
  "err.invalidToken": "リンクが無効か期限切れです。新しいリンクを請求してください。",
  "err.banned": "このアカウントは停止されています。",
  "err.nicknameCooldown": "ニックネームは{days}日に1回しか変更できません。",
  "err.alreadyVerified": "メールはすでに確認済みです。",
  "err.unauthenticated": "セッションの期限が切れました。もう一度ログインしてください。",
  "err.validation": "強調表示された項目を確認してください。",
  "err.invalidDeck": "デッキが無効です: 各ランク1枚、各カテゴリ最大1枚（エネルギーは2枚）。",
  "err.notOwned": "このアイテムはまだ持っていません。",
  "err.alreadyOwned": "このアイテムはすでに持っています。",
  "err.paymentProvider": "Mercado Pago から応答がありません。しばらくしてからもう一度お試しください。",

  "title.set": "セット1 · カントー",
  "title.start": "スタート",
  "title.tap": "タップしてスタート",
  "title.credits": "クレジット",

  "menu.title": "メニュー",
  "menu.accountLevel": "アカウントレベル {n}",
  "menu.logout": "ログアウト",
  "menu.welcome": "アカウントを作成しました！ようこそ、{name}。",
  "menu.confirmEmail": "パスワードを忘れたときに再設定できるよう、メール（{email}）を確認してください。",
  "menu.resend": "リンクを再送",
  "menu.play": "プレイ",
  "menu.play.sub": "カジュアルマッチ · 最大8人",
  "menu.ranked": "ランクマッチ",
  "menu.ranked.sub": "シーズン1 · カントー",
  "menu.ranked.locked": "メールを確認すると解放",
  "menu.deck": "カードデッキ",
  "menu.deck.sub": "ゴールド · シルバー · ブロンズ",
  "menu.ranking": "ランキング",
  "menu.ranking.sub": "シーズン上位と履歴",
  "menu.collection": "コレクション",
  "menu.collection.sub": "色違い",
  "menu.shop": "VIPショップ",
  "menu.shop.sub": "クリスタルとボード",
  "menu.friends": "友だちと遊ぶ",
  "menu.friends.text": "同じコードを入力すると全員が同じ部屋に入ります。最初に入った人が開始のタイミングを決めます。",
  "menu.friends.placeholder": "部屋コード（例: PALLET）",
  "menu.friends.join": "入室",
  "menu.linkSent": "リンクを送りました！受信箱（と迷惑メール）を確認してください。",
  "menu.err.verify": "ランクマッチで遊ぶにはメールを確認してください。",
  "menu.err.connect": "ゲームサーバーに接続できませんでした。",
  "menu.err.code": "3文字以上の英数字のコードを使ってください。",
  "menu.rejoin": "進行中の試合があります。",
  "menu.rejoin.button": "試合に戻る",
  "menu.rejoin.expired": "試合は終了したか、復帰できる時間が過ぎました。",

  "lobby.title": "対戦相手を探しています",
  "lobby.players": "プレイヤー",
  "lobby.playersCount": "プレイヤー（{n}/{max}）",
  "lobby.start": "今すぐ開始",
  "lobby.leave": "キューを抜ける",
  "lobby.you": "あなた",
  "lobby.cancelled": "人数が足りないため試合は中止されました。メニューに戻ってもう一度お試しください。",
  "lobby.hint.solo": "1人でも開始できます: PvPラウンドはゲーム内のトレーナーと戦います。人が集まるのを待つこともできます。",
  "lobby.hint.host": "あなたが部屋のオーナーです。好きなときに開始できます。",
  "lobby.hint.wait": "部屋のオーナーが開始するのを待っています（または満員になるまで）。",

  "match.level": "Lv.{n}",
  "match.badges": "バッジ",
  "match.quit": "試合を抜ける",
  "match.trainers": "トレーナー",
  "match.traits": "シナジー",
  "match.traits.empty": "盤面にユニットを置くとシナジーが発動します。",
  "match.lockShop": "ショップをロック",
  "match.free": "無料（{n}）",
  "match.round.pve": "野生",
  "match.round.pvp": "バトル",
  "match.round.safari": "サファリゾーン",
  "match.round.gym": "ジムリーダー",
  "match.err.not-enough-gold": "ゴールドが足りません",
  "match.err.bench-full": "ベンチがいっぱいです",
  "match.err.board-full": "今のレベルでは盤面がいっぱいです。XPでレベルを上げましょう",
  "match.err.max-level": "最大レベルです",
  "match.err.items-full": "このユニットはすでにアイテムを3つ持っています",
  "match.err.not-planning": "準備フェーズまで待ってください",
  "match.err.rate-limited": "落ち着いて！操作が多すぎます",
  "match.range": "射程 {n}",
  "match.mana": "マナ",
  "match.sell": "売却 +{n}",
  "match.equip": "装備",
  "match.equipHint": "素材を渡すユニットをタップしてください",
  "match.badge.choose": "バッジのボーナスを選んでください。",
  "match.branch.choose": "進化先を選んでください",
  "match.backpack": "バッグ: 素材を1つ選んでください",
  "match.safari.text": "ポケモン（素材付き）を1匹選んでください。HPが低い人から選びます。",
  "match.safari.picked": "選択を記録しました。時間切れまで変更できます。",
  "match.safari.toast": "サファリゾーン: ポケモンを選ぼう！",
  "match.gym.toast": "{leader}が勝負をしかけてきた！勝つと{badge}のボーナスを選べます。",
  "match.quit.title": "試合を抜けますか？",
  "match.quit.text": "あなたの盤面は試合が終わるまで、動かないまま残ります。メニューから戻れます。",
  "match.quit.yes": "抜ける",
  "match.quit.no": "続ける",
  "match.end.league": "カントーリーグ優勝！",
  "match.end.journey": "旅の終わり",
  "match.end.top4": "トップ4！",
  "match.end.over": "ゲーム終了",
  "match.end.points": "{n}ポイント",
  "match.end.xp": "アカウントXP +{n}",
  "match.end.levelUp": "レベル{n}になった！",
  "match.end.newCard": "新しいカード:",
  "match.end.shiny": "新しい色違いを解放！コレクションで確認しよう。",
  "match.end.menu": "メニューに戻る",
  "match.reconnecting": "接続が切れました。再接続中…",
  "match.reconnectFailed": "試合に戻れませんでした。",
  "match.vs.wild": "野生 / リーダー",
  "match.vs.npc": "ゲーム内トレーナー",
  "match.combat": "バトル",
  "match.combatVs": "バトル · vs {name}",

  "tip.component": "素材",
  "tip.item": "アイテム",
  "tip.combine": "同じユニットに素材を2つ持たせるとアイテムになります:",
  "tip.onBoard": "盤面に{n}体",
  "stat.adPct": "攻撃ダメージ +{v}%",
  "stat.ap": "スキル威力 +{v}",
  "stat.asPct": "攻撃速度 +{v}%",
  "stat.critPct": "急所率 +{v}%",
  "stat.armor": "防御力 +{v}",
  "stat.mr": "特防 +{v}",
  "stat.hp": "HP +{v}",
  "stat.startMana": "初期マナ +{v}",

  "tier.gold": "ゴールド",
  "tier.silver": "シルバー",
  "tier.copper": "ブロンズ",
  "deck.title": "カードデッキ",
  "deck.yours": "あなたのデッキ · カントー",
  "deck.empty": "空き",
  "deck.emptyHint": "下のコレクションからこのランクのカードを選んでください。",
  "deck.save": "デッキを保存",
  "deck.rules": "各ランク1枚 · エネルギーは最大{energy}枚、それ以外は各カテゴリ1枚まで",
  "deck.allUnlocked": " · すべて解放済み（レベル{n}以上）",
  "deck.unlockAt": " · レベル{n}ですべて解放",
  "deck.collection": "コレクション",
  "deck.all": "すべて",
  "deck.locked": "レベルアップで入手",
  "deck.saved": "デッキを保存しました！次の試合から適用されます。",
  "deck.needAll": "各ランク（ゴールド・シルバー・ブロンズ）のカードを1枚ずつ選んでください。",

  "ranking.title": "ランキング",
  "ranking.noSeason": "現在開催中のシーズンはありません。",
  "ranking.endsIn": "残り{n}日",
  "ranking.you": "あなた:",
  "ranking.unranked": "ランクマッチの記録なし",
  "ranking.placement": "残り{n}試合の格付け戦（ポイント2倍）",
  "ranking.trainer": "トレーナー",
  "ranking.games": "試合数",
  "ranking.elo": "ランク",
  "ranking.gamesWins": "{n}（{w}勝）",
  "ranking.empty": "まだ誰もランクマッチをしていません。一番乗りしよう！",
  "ranking.history": "最近の試合",
  "ranking.placeOf": "{n}人中{p}位",
  "ranking.mode.ranked": "ランクマッチ",
  "ranking.mode.custom": "友だちと",
  "ranking.mode.normal": "カジュアル",
  "ranking.noMatches": "まだ試合がありません。",
  "ranking.pts": "{n}pt",
  "rank.pokeball": "モンスターボール",
  "rank.greatball": "スーパーボール",
  "rank.ultraball": "ハイパーボール",
  "rank.masterball": "マスターボール",

  "collection.title": "コレクション",
  "collection.text": "色違いは見た目だけの変化で、試合では全員に表示されます。ポケドルで買うか、アカウントレベル（5レベルごと）とシーズンの最高ランクで入手できます。",
  "collection.showOwned": "所持のみ表示",
  "collection.showingOwned": "所持のみ表示中",
  "collection.count": "{total}中{n}",
  "collection.tapToEquip": "タップで装備",
  "rarity.common": "コモン",
  "rarity.rare": "レア",
  "rarity.epic": "エピック",
  "rarity.legendary": "レジェンド",

  "shop.title": "VIPショップ",
  "shop.crystals": "クリスタル",
  "shop.tab.boards": "ボード",
  "shop.tab.crystals": "クリスタル",
  "shop.tab.history": "履歴",
  "shop.boards.explain": "ボードは試合のアリーナを変えます。2人の対戦では、HPが多い方のボードを2人とも見ます。次に対戦したときはもう一方のボードになります。見た目だけで有利にはなりません。",
  "shop.default": "デフォルト",
  "shop.default.desc": "おなじみの青と赤のスタジアム。誰でも無料。",
  "shop.equip": "装備",
  "shop.equipped": "装備中",
  "shop.animated": "アニメ",
  "shop.preview": "プレビュー",
  "shop.confirmBuy": "購入する？ {price}",
  "shop.bought": "{name}を購入して装備しました！",
  "shop.notEnough": "クリスタルが足りません。クリスタルパックを見てみよう。",
  "shop.crystals.explain": "クリスタルはサーバー運営を支える寄付です。見た目のアイテムにだけ使え、ゲームで有利になることはありません。",
  "shop.bonus": "ボーナス",
  "shop.donate": "{price}を寄付",
  "shop.mp.note": "支払いは Mercado Pago（Pix・カード・ボレト）で処理されます。承認されしだいクリスタルが追加されます。",
  "shop.devMode": "テストモード: 請求はありません（Mercado Pago 未設定のサーバー）。",
  "shop.paymentsOff": "現在、寄付はご利用いただけません。",
  "shop.donation.ok": "寄付ありがとうございます！クリスタル{n}個を追加しました。",
  "shop.donation.waiting": "支払いの確認を待っています…",
  "shop.donation.failed": "支払いは完了しませんでした。請求はありません。",
  "shop.history.empty": "まだ寄付はありません。",
  "shop.history.date": "日付",
  "shop.history.value": "金額",
  "shop.history.status": "状態",
  "shop.status.pending": "保留中",
  "shop.status.in_process": "審査中",
  "shop.status.approved": "承認済み",
  "shop.status.rejected": "拒否",
  "shop.status.cancelled": "キャンセル",
  "shop.status.refunded": "返金済み",
  "shop.status.charged_back": "チャージバック",
  "shop.devCheckout.title": "テスト決済",
  "shop.devCheckout.text": "この寄付の支払い結果をシミュレートします。",
  "shop.devCheckout.approve": "支払いを承認",
  "shop.devCheckout.reject": "拒否",

  "credits.title": "クレジット",
  "credits.sprites": "ポケモンのスプライト",
  "credits.spritesText": "アニメーション: {source}（ライセンス {license}）。アート:",
  "credits.items": "アイテム・データ・フォント",
  "credits.itemsText": "アイテムアイコン、名前、ポケモンのデータ: {source} / PokéAPI。",
  "credits.fonts": "フォント: Jersey 10、DotGothic16（SIL Open Font License）。",
  "credits.trademark": "ポケモンおよび関連する名称は任天堂・ゲームフリーク・クリーチャーズの商標です。非公式のファンプロジェクトです。",
  "credits.error": "クレジットを読み込めませんでした。",

  // efeitos de combate
  "fx.effective": "ばつぐん",
  "fx.shield": "シールド",
  "fx.stun": "スタン",
  "fx.sleep": "zzz",
  "fx.freeze": "こおり",
  "fx.confuse": "こんらん",
  "fx.burn": "やけど",
  "fx.poison": "どく",
  "fx.intangible": "むてき",
  // foto de perfil
  "avatar.change": "プロフィール画像を変更",
  "avatar.title": "プロフィール画像を選ぼう",
  "avatar.search": "ポケモンを検索",
  "avatar.saved": "プロフィール画像を更新しました！",
  "market.title": "フレンドリィショップ",
  "market.tab.special": "スペシャル",
  "market.tab.item": "完成アイテム",
  "market.tab.component": "素材",
  "market.explain": "買ったアイテムはアイテムプールに入ります。試合の報酬で、プールの完成アイテムが完成した状態で出ることがあり（1個につき6%、最大30%）、プールの素材は2倍出やすくなります。",
  "market.inPool": "プールに{n}個。",
  "market.owned": "プールにあり",
  "market.bought": "{name}をアイテムプールに追加しました！",
  "match.end.pokedollars": "+{n} ポケドル",
  "menu.market": "ショップ",
  "menu.market.sub": "ポケドルでアイテム",
  "pdx.confirm": "買う？ {price}",
  "pdx.explain": "ポケドル: 1試合で0〜100もらえます（1位=100）。カード・色違い・アイテムが買えます。",
  "pdx.notEnough": "ポケドルが足りません。試合をして集めよう。",
  "tip.special": "スペシャル",
  "tip.specialHint": "ショップ限定: 試合で完成した状態で出て、2枠を使います。",
  "changelog.title": "お知らせ",
  "changelog.version": "バージョン {v}",
  "changelog.new": "NEW",
  "changelog.link": "バージョン {v} の新機能",
  "tip.unit.cost": "コスト{n}",
  "tip.unit.evolves": "進化:",
  "tip.unit.branch": "選択式",
  "tip.unit.owned": "すでに{n}体持っています。3体で★2になります。",
  "social.title": "フレンドとチャット",
  "social.global": "全体",
  "social.friendsTab": "フレンド",
  "social.say": "メッセージを入力…",
  "social.send": "送信",
  "social.empty": "まだメッセージはありません。",
  "social.addPlaceholder": "フレンドのユーザー名",
  "social.add": "追加",
  "social.incoming": "フレンド申請",
  "social.outgoing": "送った申請",
  "social.friends": "フレンド（{n}）",
  "social.noFriends": "ユーザー名でフレンドを追加しよう。",
  "social.remove": "削除",
  "social.requestSent": "申請を送りました！",
  "social.nowFriends": "フレンドになりました！",
  "social.roomChat": "部屋のチャット",
  "social.err.notFound": "ユーザーが見つかりません。",
  "social.err.self": "自分は追加できません。",
  "social.err.already": "すでにフレンドです。",
  "social.err.notFriends": "フレンドとだけチャットできます。",
  "menu.creche": "育て屋",
  "menu.creche.sub": "ポケモンを育てて解放",
  "creche.title": "育て屋",
  "creche.explain": "ロックされた系統のポケモンをレベル{max}まで育てると、その系統が試合のショップに並ぶようになります。お世話をして試合をすると、一緒に経験値を得ます。",
  "creche.level": "レベル {n}/{max}",
  "creche.unlocks": "{name}の系統を解放",
  "creche.xp": "経験値",
  "creche.belly": "おなか",
  "creche.happiness": "なかよし度",
  "creche.mood.hungry": "おなかがすいている！ごはんをあげると経験値が満額になります。",
  "creche.mood.sad": "さみしそう…遊んであげよう。",
  "creche.mood.joy": "とてもうれしそう！試合で経験値が満額。",
  "creche.mood.ok": "元気です。試合で経験値が満額。",
  "creche.feed": "ごはん",
  "creche.play": "遊ぶ",
  "creche.train": "特訓",
  "creche.tips": "試合ごとに20経験値（おなかがすいている・さみしいときは10）。遊ぶ: 30分ごと。特訓: 2時間ごと、30経験値。",
  "creche.release": "このポケモンを逃がす",
  "creche.releaseConfirm": "もう一度タップで逃がす（進行は失われます）",
  "creche.choose": "育てるポケモンを選んでください。最大レベルになると、その系統が試合のショップに並びます。",
  "creche.allDone": "すべての系統を解放しました！図鑑完成です。",
  "creche.dex": "カントー図鑑: {total}中{n}解放",
  "creche.adopted": "{name}が育て屋にやってきた！",
  "creche.unlocked": "{name}がショップに並ぶようになった！",
  "creche.gotXp": "+{n} 経験値",
  "creche.err.not-hungry": "いまはおなかがすいていません。",
  "creche.err.too-hungry": "おなかがすきすぎています。先にごはんを。",
  "creche.err.too-sad": "さみしくて特訓できません。遊んであげよう。",
  "creche.err.cooldown": "少し休ませてあげよう。",
  "menu.missions": "ミッション",
  "menu.missions.sub": "毎日₽がもらえる",
  "missions.title": "デイリーミッション",
  "missions.intro": "試合をしてミッションを達成し、報酬を受け取ろう。次の更新まで",
  "missions.resetsIn": "{t}",
  "missions.streak": "{n}日連続ログイン",
  "missions.best": "最高: {n}",
  "missions.completedTotal": "達成ミッション {n}",
  "missions.seeRanking": "ランキングを見る",
  "missions.claimed": "受け取り済み",
  "missions.got": "+₽ {n}!",
  "missions.hint": "進行は試合終了時に反映されます。",
  "missions.doneInMatch": "ミッションを{n}個達成！報酬を受け取ろう。",
  "missions.k.synergy": "1試合で{trait}を{n}体そろえる",
  "missions.k.play": "{n}回試合をする",
  "missions.k.win": "{n}回勝利する",
  "missions.k.tophalf": "上位半分で{n}回終える",
  "missions.k.ranked-play": "ランクマッチを{n}回プレイ",
  "missions.k.ranked-win": "ランクマッチで{n}回勝利",
  "missions.k.pvp-wins": "プレイヤーとの対戦で{n}ラウンド勝つ",
  "missions.k.star3": "★3のポケモンをつくる",
  "missions.k.items": "盤面に完成アイテムを{n}個そろえる",
  "missions.k.level": "1試合でレベル{n}に到達",
  "ranking.tab.ranked": "ランク",
  "ranking.tab.level": "レベル",
  "ranking.tab.missions": "ミッション",
  "ranking.tab.streak": "連続ログイン",
  "ranking.about.level": "アカウントレベル：試合ごとの経験値で上がります。",
  "ranking.about.missions": "達成して受け取ったデイリーミッションの合計。",
  "ranking.about.streak": "連続でログインした日数。1日休むとリセットされます。",
  "ranking.col.level": "レベル",
  "ranking.col.missions": "ミッション",
  "ranking.col.streak": "日数",
  "ranking.levelValue": "Lv. {n}",
  "ranking.missionsValue": "{n}",
  "ranking.streakValue": "{n}日",
  "ranking.bestStreak": "最高 {n}",
  "match.migrating": "サーバー更新中…試合に戻ります。",
  "queue.searching": "対戦相手を探しています…",
  "queue.searchingRanked": "ランクマッチを探しています…",
  "queue.starting": "キューに参加中",
  "queue.progress": "{time} · 待機 {n}人 · 範囲 ±{range}",
  "queue.cancel": "キャンセル",
  "match.vs.ghost": "{name}（記録された盤面）",
  "common.sound": "サウンドと振動",
  "menu.achievements": "実績",
  "menu.achievements.sub": "称号とフレーム",
  "ach.title": "実績",
  "ach.unlocked": "解除済み",
  "ach.titleLabel": "称号",
  "ach.frameLabel": "フレーム",
  "ach.none": "なし",
  "ach.secretName": "ひみつの実績",
  "ach.secretDesc": "プレイを続けて見つけよう。",
  "ach.frameReward": "フレーム",
  "ach.saved": "プロフィールを更新しました。",
  "ach.cat.jornada": "冒険",
  "ach.cat.colecao": "コレクション",
  "ach.cat.habilidade": "腕前",
  "ach.cat.secreta": "ひみつ",
  "ach.frame.ouro": "ゴールド",
  "ach.frame.prata": "シルバー",
  "ach.frame.master": "マスターボール",
  "ach.frame.pokedex": "ポケモン図鑑",
  "ach.frame.shiny": "色違い",
  "ach.toast": "実績解除：{name}！",
  "ach.inMatch": "新しい実績が{n}個！",
  "report.button": "通報・ブロック",
  "report.title": "{name}を通報",
  "report.why": "何がありましたか？",
  "report.reason.nickname": "不適切な名前",
  "report.reason.chat": "不適切なチャット・スパム",
  "report.reason.afk": "放置・離脱",
  "report.reason.cheating": "不正行為",
  "report.reason.other": "その他",
  "report.details": "詳細（任意）",
  "report.alsoBlock": "この人をブロックする",
  "report.note": "最近のメッセージを証拠として保存します。虚偽の通報はペナルティの対象になります。",
  "report.send": "通報する",
  "report.blockOnly": "ブロックのみ",
  "report.unblock": "ブロック解除",
  "report.thanks": "ありがとうございます。運営が確認します。",
  "social.muted": "チャットは{when}まで制限されています。",
  "mod.title": "モデレーション",
  "mod.open": "未対応",
  "mod.closed": "対応済み",
  "mod.by": "{name} · {when}",
  "mod.counts": "未対応{open}件 · {people}人から",
  "mod.mutedUntil": "{when}までチャット制限",
  "mod.bannedUntil": "{when}まで停止",
  "mod.nickAtTime": "当時の名前：{name}",
  "mod.evidence": "証拠（{n}件）",
  "mod.room": "ルーム",
  "mod.noEvidence": "保存されたメッセージはありません。",
  "mod.dismiss": "却下",
  "mod.mute24": "24時間ミュート",
  "mod.rename": "名前を変更",
  "mod.ban3d": "3日間停止",
  "mod.ban1y": "BAN",
  "mod.confirm": "確認？",
  "mod.result": "{action} · {when}",
  "mod.empty": "通報はありません。",
  "mod.done": "完了。",
  "menu.moderation": "モデレーション",
  "share.tagline": "ブラウザで遊べるポケモンオートチェス",
  "share.ofN": "{n}人中",
  "share.solo": "ソロ",
  "share.trainer": "トレーナー",
  "share.team": "わたしのチーム",
  "share.level": "レベル{n}",
  "share.round": "ラウンド{r}",
  "share.wins": "{n}勝",
  "share.cta": "無料・ダウンロード不要",
  "share.text": "PokéChessで{n}人中{place}位になった！無料で遊べる：{url}",
  "share.button": "結果をシェア",
  "share.downloaded": "画像を保存しました！",
  "ach.primeira-partida.name": "はじめの一歩",
  "ach.primeira-partida.desc": "初めての試合をプレイする。",
  "ach.partidas-10.name": "かけだしトレーナー",
  "ach.partidas-10.desc": "{n}回試合をする。",
  "ach.partidas-100.name": "ベテラン",
  "ach.partidas-100.desc": "{n}回試合をする。",
  "ach.partidas-1000.name": "カントーの伝説",
  "ach.partidas-1000.desc": "{n}回試合をする。",
  "ach.primeira-vitoria.name": "はじめての勝利",
  "ach.primeira-vitoria.desc": "他のプレイヤーとの試合で1位になる。",
  "ach.vitorias-10.name": "チャンピオン",
  "ach.vitorias-10.desc": "{n}回勝利する。",
  "ach.vitorias-50.name": "無敵",
  "ach.vitorias-50.desc": "{n}回勝利する。",
  "ach.top4-25.name": "常連入賞",
  "ach.top4-25.desc": "上位4位以内に{n}回入る。",
  "ach.ranqueada-vitorias-10.name": "リーグのエース",
  "ach.ranqueada-vitorias-10.desc": "ランクマッチで{n}回勝利する。",
  "ach.master-ball.name": "ポケモンマスター",
  "ach.master-ball.desc": "シーズンでマスターボールに到達する。",
  "ach.dias-7.name": "1週間皆勤",
  "ach.dias-7.desc": "{n}日連続でプレイする。",
  "ach.dias-30.name": "皆勤賞",
  "ach.dias-30.desc": "{n}日連続でプレイする。",
  "ach.missoes-50.name": "ミッション達人",
  "ach.missoes-50.desc": "デイリーミッションを{n}個達成する。",
  "ach.nivel-20.name": "熟練トレーナー",
  "ach.nivel-20.desc": "アカウントレベル{n}に到達する。",
  "ach.criadouro-1.name": "育て屋デビュー",
  "ach.criadouro-1.desc": "育て屋で系統を1つ解放する。",
  "ach.pokedex-completa.name": "博士",
  "ach.pokedex-completa.desc": "育て屋の{n}系統をすべて解放する。",
  "ach.shinies-5.name": "めずらしい色",
  "ach.shinies-5.desc": "色違いを{n}体集める。",
  "ach.shinies-25.name": "色違いハンター",
  "ach.shinies-25.desc": "色違いを{n}体集める。",
  "ach.cartas-10.name": "コレクター",
  "ach.cartas-10.desc": "カードを{n}枚集める。",
  "ach.agua-7.name": "みずのマスター",
  "ach.agua-7.desc": "1試合でみずを7体そろえる。",
  "ach.voador-7.name": "空の支配者",
  "ach.voador-7.desc": "1試合でひこうを7体そろえる。",
  "ach.brigao-6.name": "けんか番長",
  "ach.brigao-6.desc": "1試合でブローラーを6体そろえる。",
  "ach.muralha-6.name": "不動",
  "ach.muralha-6.desc": "1試合でウォールを6体そろえる。",
  "ach.tres-estrelas-3.name": "三つ星",
  "ach.tres-estrelas-3.desc": "★3のポケモンを同時に3体出す。",
  "ach.vitoria-por-um-fio.name": "ギリギリの勝利",
  "ach.vitoria-por-um-fio.desc": "HP5以下で勝利する。",
  "ach.nivel-9.name": "レベル9",
  "ach.nivel-9.desc": "1試合でレベル9に到達する。",
  "ach.itens-6.name": "武器庫",
  "ach.itens-6.desc": "盤面に完成アイテムを6個そろえる。",
  "ach.giovanni.name": "サカキに勝利",
  "ach.giovanni.desc": "ソロで8-7までクリアする。",
  "ach.dragonite-3.name": "伝説のドラゴン",
  "ach.dragonite-3.desc": "カイリューを★3にする。",
  "ach.magikarp-3.name": "はねる！",
  "ach.magikarp-3.desc": "コイキングを★3にする。",
  "ach.so-custo-1.name": "謙虚",
  "ach.so-custo-1.desc": "コスト1のポケモンだけで勝利する。",
  "ach.sem-vitoria-top4.name": "サバイバー",
  "ach.sem-vitoria-top4.desc": "一度も勝たずに上位4位に入る。",
  "ach.mewtwo.name": "最強のクローン",
  "ach.mewtwo.desc": "ミュウツーを場に出す。",
  "tut.coach": "オーキド博士",
  "tut.next": "次へ",
  "tut.shop": "ここはショップ。ポケモンをタップして購入しよう。数字はゴールドの値段だよ。",
  "tut.place": "ベンチに入ったね。盤面にドラッグしよう。盤面にいるポケモンだけが戦うよ。",
  "tut.fight": "準備はいい？「バトル！」をタップ。戦いは自動だよ。",
  "tut.watch": "ポケモンは自動で戦う。勝つとゴールドとアイテムがもらえるよ。",
  "tut.combine": "同じポケモン3体で★2になってぐっと強くなる。持っているポケモンはショップで光るよ。",
  "tut.traits": "同じタイプのポケモンでシナジーが発動。シナジーで確認しよう。",
  "tut.items": "素材をゲット！素材をタップしてからポケモンをタップして装備しよう。素材2つでアイテムになるよ。",
  "tut.xp": "経験値を買ってレベルアップ。レベルごとに盤面のポケモンが1体増やせるよ。",
  "tut.interest": "上級者のコツ：ゴールドを貯めると利子がつく。10ごとに+1（最大+5）。",
  "tut.end": "さあ本番！このバトルに勝てばチュートリアル完了だ。",
  "tut.fightBtn": "バトル！",
  "tut.offerTitle": "はじめてかな？",
  "tut.offer": "3分のガイド付き試合で遊び方を覚えて、₽ {n}をもらおう。",
  "tut.start": "チュートリアルを始める",
  "tut.skip": "遊び方は知っている",
  "tut.done": "チュートリアル完了！",
  "menu.tutorial": "チュートリアル",
  "menu.tutorial.sub": "3分で覚える",
  "lobby.fillBots": "ボットで埋める",
  "lobby.fillBotsHint": "空いた席はゲームのトレーナーになります。",
};
export default ja;
